module.exports = __webpack_public_path__ + "img/empty-wallet.7206e833.svg";